import { createContext, useContext, PropsWithChildren, useState } from "react";

type HeroContextType = {
    readonly modalIndex: number;
    readonly openModal: (num: number) => void;
    readonly closeModal: () => void;
};
const initVal = {
    modalIndex: -1,
    closeModal: () => -1,
    openModal: () => 0
};

export const HeroContext = createContext<HeroContextType>(initVal);

export const useHeroState = () => {
    return useContext(HeroContext);
};

export const HeroContextProvider = ({ children }: PropsWithChildren) => {
    const [modalIndex, setModalIndex] = useState(-1);
    const openModal = (num: number) => setModalIndex(num);
    const closeModal = () => setModalIndex(-1);

    return (
        <HeroContext.Provider value={{ modalIndex, openModal, closeModal }}>
            {children}
        </HeroContext.Provider>
    );
};
